import BaseSelector, { hookFromSelector, withStaticSelector } from './BaseSelector'

class QuestionsBuilderSelector extends BaseSelector {
	static fromStoreState(store) {
		return new this(store.quiz.builder)
	}

	@hookFromSelector('useActiveQuestionId')
	@withStaticSelector
	selectActiveQuestionId() {
		return this.state?.activeQuestionId
	}

	@hookFromSelector('useActiveCategoryId')
	@withStaticSelector
	selectActiveCategoryId() {
		return this.state?.activeCategoryId
	}

	@hookFromSelector('useQuestionAdditionEnabled')
	@withStaticSelector
	selectQuestionAdditionEnabled() {
		return this.state?.questionAdditionEnabled
	}

	@hookFromSelector('usePageId')
	@withStaticSelector
	selectPageId() {
		return this.state?.pageId
	}

	@hookFromSelector('useQuestionTab')
	@withStaticSelector
	selectQuestionTab() {
		return this.state?.questionTab
	}

	@hookFromSelector('useCategoryTab')
	@withStaticSelector
	selectCategoryTab() {
		return this.state?.categoryTab
	}

	@hookFromSelector('useGallery')
	@withStaticSelector
	selectGallery() {
		return this.state?.gallery
	}

	@hookFromSelector('useIsGalleryActive')
	@withStaticSelector
	selectIsGalleryActive() {
		return !!this.selectGallery()
	}

	@hookFromSelector('useOptionMinimize')
	@withStaticSelector
	selectOptionMinimize() {
		return this.state?.optionMinimize
	}

	@hookFromSelector('useOptionOpened')
	@withStaticSelector
	selectOptionOpened(id) {
		const minimized = this.selectOptionMinimize()[id]

		return !(minimized ?? true)
	}

	@hookFromSelector('useIsSettingsActive')
	@withStaticSelector
	selectIsSettingsActive() {
		return this.selectIsQuestionSettingsActive() || this.selectIsCategorySettingsActive() || !!this.selectGallery()
	}
}

export default QuestionsBuilderSelector
